import { generateChart } from './DefaultChart'
import { reactiveData } from './mixins/data-update'
import { SuperDuperLineController, indicatorsPlugin, interpolate} from './extra/'
import { Interaction } from 'chart.js'

const createGraient = (
  canvasCtx,
  [startX, startY, endX, endY],
  colorsList = []
) => {
  const gradientFill = canvasCtx.createLinearGradient(startX, startY, endX, endY)
  colorsList.forEach(([stop, color]) => {
    gradientFill.addColorStop(stop, color)
  })

  return gradientFill
}

const defaultLineChartStyles = (canvasCtx) => ({
  borderColor: '#30A7FE',
  pointBackgroundColor: '#CCEBFF',
  pointHoverBackgroundColor: '#CCEBFF',
  //   pointHoverBorderColor: gradientStroke,
  pointBorderWidth: 0,
  pointHoverRadius: 6,
  pointHoverBorderWidth: 1,
  pointRadius: 5,
  fill: true,
  backgroundColor: createGraient(canvasCtx, [0, 1200, 0, 0], [[0, 'rgba(0, 82, 180, 0.54)'], [1, 'rgba(13, 13, 13, 0)']]),
  borderWidth: 0.5,
  lineTension: 0.3,
  interpolate: true,
  showLine: true
})

const defaultChartData = (canvasCtx) => ({
  labels: [],
  datasets: [
    {
      ...defaultLineChartStyles(canvasCtx),
      data: []
    }
  ]
})

const Line = generateChart('LineChart', 'SuperDuperLine')

export default {
  extends: Line,
  mixins: [reactiveData],
  props: {
    dataToRender: {
      type: Array,
      default: () => [],
      required: true
    },
    displayDots: {
      type: Boolean,
      default: true
    }
  },
  watch: {
    dataToRender: {
      handler: function (newData, oldData) {
        // if (!this.chartData) this.initChart();
        if (JSON.stringify(newData) !== JSON.stringify(oldData)) {
          setTimeout(this.fillData.bind(this, newData), 0)
        }
      },
      deep: true,
      immediate: true
    },
    displayDots: {
      handler: function (newValue) {
        if (this.chartData) {
          this.chartData.datasets[0].pointRadius = newValue ? 5 : 0
        }
        if (this.$data._chart) {
          this.$data._chart.update()
        }
      },
      immediate: true
    }
  },
  data() {
    return {
      chartData: null,
      options: {
        interaction: {
            mode: 'interpolate',
            intersect: false
            // axis: "x"
        },
        onResize: function (chart, { width, height }) {
          if (width < 600) {
            chart.options.maintainAspectRatio = false
            // chart.canvas.parentNode.style.height = '128px';
            // chart.canvas.parentNode.style.width = '128px';
            chart.options.scales.y.ticks.display = false
          } else {
            // chart.options.maintainAspectRatio = true;
            // chart.canvas.parentNode.style.height = '700px';
            // chart.canvas.parentNode.style.width = '1280px';
            chart.options.scales.y.ticks.display = true
          }
          if (chart.data.datasets.length > 0) {
            const gradient = createGraient(this.ctx, [width, 100, width, height + 100], [[0, 'rgba(0, 82, 180, 0.54)'], [1, 'rgba(13, 13, 13, 0)']])
            chart.data.datasets[0].backgroundColor = gradient
          }
        },
        plugins: {
          // crosshair: {
          //   line: {
          //     // Add alpha chanel so line becomes transparant so you dont see it
          //     color: '#ffffff00',
          //   },
          //   sync: {
          //     enabled: false
          //   },
          //   zoom: {
          //     enabled: false
          //   }
          // },
          legend: {
            display: false
          },
          // tooltip: {
          //   // mode: 'nearest',
          //   // intersect: false/
          // }
          tooltip: {
            displayColors: false,
            mode: 'interpolate',
            intersect: false,
            yAlign: 'bottom',
            cornerRadius: 16,
            caretPadding: 8,
            caretSize: 8,
            backgroundColor: 'white',
            bodyColor: '#0C2D45',
            bodyFont: {
              family: 'Open Sans',
              weight: 14,
              size: 16
            },
            titleMarginBottom: 0,
            titleSpacing: 0,
            footerMarginTop: 0,
            footerSpacing: 0,
            padding: {
              top: 12,
              bottom: 12,
              left: 16,
              right: 16
            },
            bodySpacing: 0,
            callbacks: {
              beforeTitle: function () { },
              title: function () { },
              labelTextColor: function () {
                return 'black'
              },
              beforeLabel: function () {
                return ''
              },
              label: function (context) {
                // debugger;
                var label = context.dataset.label || ''

                if (label) {
                  label += ': '
                }
                if (context.formattedValue !== null) {
                  label = new Intl.NumberFormat('en-US', {
                    style: 'currency',
                    currency: 'EUR',
                    maximumFractionDigits: 0
                  }).format(context.formattedValue)
                }
                return label
              }
            }
          }
        },
        scales: {
          y: {
            display: true,
            afterFit: function (scale) {
              // console.log(scale);
              // scale.paddingRight = 44;
              // scale.width = 0; //<-- set value as you wish
            },
            grid: {
              drawBorder: false,
              color: '#6D818F'
            },
            ticks: {
              color: 'white',
              font: {
                family: 'Montserrat',
                weight: 600
              },
              // autoSkipPadding: 84,
              padding: 44,
              // labelOffset: -15,
              callback: function (val, index) {
                // Hide the label of every 2nd dataset
                return '€' + this.getLabelForValue(val)
              }
              // stepSize: 84
            }
          },
          x: {
            display: true,
            grid: {
              display: false
            },
            ticks: {
              padding: 16,
              color: 'white',
              font: {
                family: 'Montserrat',
                weight: 600
              }
            }
          }
        },
        animation: {
          easing: 'easeInOutBack'
        },
        responsive: true,
        datasetStrokeWidth: 3,
        pointDotStrokeWidth: 4,
        tooltipFontStyle: 'bold',
        showScale: false,
        maintainAspectRatio: false
      }
    }
  },
  created() {
    // this.initChart();
  },
  mounted() {
    this.renderChart(this.chartData, this.options, [SuperDuperLineController, indicatorsPlugin])
  },
  methods: {
    fillData(data = []) {
      Interaction.modes.interpolate = interpolate
      this.chartData = { ...defaultChartData(this.$data._chart.ctx) }

      data.forEach(([label, value], index) => {
        this.chartData.labels.push(label)
        this.chartData.datasets[0].data.push(value)
      })
    }
  }
}
